import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-background p-6 text-center">
      <div className="max-w-md">
        <h1 className="font-heading text-3xl font-semibold tracking-tight">That page is not in the register</h1>
        <p className="mt-3 leading-7 text-muted-foreground">
          The address may be incomplete or the record is no longer available.
        </p>
        <Button className="mt-7" render={<Link to="/" />} data-jr-key="not-found-home">
          Return to Hive Register
        </Button>
      </div>
    </main>
  );
}
